document.addEventListener("DOMContentLoaded", function() {
  const thumbs = document.querySelectorAll(".block__ai-images-demo-thumbs li");
  const mainImage = document.querySelector(".ai-images-demo-main-image");

  thumbs.forEach((thumb) => {
    thumb.addEventListener("mouseenter", function() { // hover effect
      const newSrc = this.getAttribute("data-src");

      // Replace main image src and srcset
      mainImage.setAttribute("src", newSrc);
      mainImage.setAttribute("srcset", newSrc);
      
      // active class switch
      thumbs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");
    });

    thumb.addEventListener("click", function() { // also change on click
      const newSrc = this.getAttribute("data-src");

      mainImage.setAttribute("src", newSrc);
      mainImage.setAttribute("srcset", newSrc);

      thumbs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");
    });
  });
});
